import * as React from "react";
import type { FC, PropsWithChildren } from "react";

export const Nobr: FC<PropsWithChildren<{}>> = ({ children }) => (
    <span style={{ whiteSpace: "nowrap" }}>{children}</span>
);
